import { Inject, Pipe, PipeTransform } from '@angular/core';

import { Feature, TypedFeatureProperties } from '@vi-iot/client';
import { Unit } from '../../shared/common/units';

import { getTransformedEnergyDetailsFromFeature } from '../helpers/energy';
import { DEFAULT_UNITS_ADAPTER_IT } from '../services/units-adapter/units-adapter.module';
import { UnitsAdapter } from '../services/units-adapter/units.adapter';

@Pipe({
  name: 'unit',
})
export class UnitPipe implements PipeTransform {
  energyHoursUnits = [Unit.WattHour, Unit.KilowattHour, Unit.MegawattHour];
  energyUnits = [Unit.Watt, Unit.Kilowatt, Unit.Megawatt];

  constructor(@Inject(DEFAULT_UNITS_ADAPTER_IT) public unitsAdapter: UnitsAdapter) {}

  transform(feature: Feature<unknown, unknown> | string, propertyName?: string): string {
    let unitType = typeof feature === 'string' ? feature : feature?.properties[propertyName]?.unit;

    const isEnergyHourUnitFeature =
      typeof feature !== 'string' && this.energyHoursUnits.includes(unitType);
    const isEnergyUnitFeature = typeof feature !== 'string' && this.energyUnits.includes(unitType);

    if (isEnergyHourUnitFeature || isEnergyUnitFeature) {
      const { unit } = getTransformedEnergyDetailsFromFeature(
        feature as Feature<TypedFeatureProperties<number>, never>, // will not matter after migration
        propertyName
      );
      unitType = unit;
    }

    return this.unitsAdapter.getSuffix(unitType);
  }
}
